<template>
    <div class="card-box m-b-10 p-10 relative card_color_left" :style="`border-left-color:${segment.color}`">
        <div class="table-box table_fixed table_deals">

            <!-- Infos Integrations -->
            <div class="table-detail">
                {{ item.content.title }}
                <small class="show"><b>({{ item.content.domain }})</b></small>
            </div>

            <div class="table-detail">

                <!-- Member -->
                <span class="text-muted show m-t-10" v-if="item.content.member_id && item.content.auto_assign === 'no'" v-pml-tooltip="$t('consultant')">
                    <i class="md-headset-mic text-dark"></i> {{ item.content.member_id | pmlMemberById }}
                </span>
                <!-- Auto Assign -->
                <span class="text-muted show m-t-10" v-if="item.content.auto_assign === 'yes'" v-pml-tooltip="$t('approach')">
                    {{ $t('auto_assign') }}: {{ $t('_integrations.approaches.' + item.content.approach) }}
                </span>

                <!-- Follower -->
                <small class="text-muted" v-pml-tooltip="$t('follower')" v-if="item.content.follower_id">
                    <i class="fa fa-location-arrow text-dark m-r-5"></i> {{ item.content.follower_id | pmlMemberById }}
                </small>

            </div>


            <div class="table-detail t_center">

                <!-- Source -->
                <span class="label label-default" :style="`background-color:${source.color}`" v-pml-tooltip="$t('source')" v-if="item.content.source_id">{{ source.name }}</span>

            </div>

            <div class="table-detail t_center">

                <!-- Segment -->
                <span class="label label-default" :style="`background-color:${segment.color}`" v-pml-tooltip="$t('segment')" v-if="item.content.segment_id">{{ segment.name }}</span>

                <!-- Pipeline -->
                <span class="show m-t-5" v-if="item.content.pipeline_step_id" v-pml-tooltip="$t('pipeline')"><i class="fa fa-toggle-right text-dark m-r-5"></i> {{ item.content.pipeline_step_id | pmlPipelineByStepId }} <i class="fa fa-long-arrow-right"></i> {{ item.content.pipeline_step_id | pmlPipelineStepById }}</span>
            </div>

            <!-- Actions -->
            <div class="table-detail t_right w_100">
                <router-link :to="{ name: 'integrations.informs.edit', params: { id: item.id } }" class="btn btn-warning btn-xs" v-pml-tooltip="$t('edit')">
                    <i class="fa-fw fa fa-pencil"></i>
                </router-link>
                <span class="btn btn-danger btn-xs" v-pml-tooltip="$t('delete')" @click.prevent="askToDelete" v-pml-block="isDeleting">
                    <i class="fa-fw fa fa-times"></i>
                </span>
            </div>

        </div>

        <!-- Script Integration -->
        <div class="copy_code m-t-10">
            <figure class="highlight">
                <pre class="m-0"><code class="language-html" v-html="scriptCode"></code></pre>
            </figure>
            <button class="btn btn-primary btn-sm"  v-pml-tooltip.left="$t('copy')" v-clipboard='`<script type="text/javascript">${code}</script>`' @success="handleSuccess()"><i class="fa fa-copy"></i></button>
        </div>

    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { destroyInForms, updateInForms } from 'services/integrations'
    import { askToDelete } from 'utils/helpers/sweet-alert'
    import { findSource, findSegment } from 'utils/helpers/find-store'
    import { indexOf } from 'lodash'
    import { mapGetters } from 'vuex'

    export default {
        name: 'InFormsItem',
        props: [ 'item' ],
        data () {
            return {
                isDeleting: false
            }
        },
        computed: {
            ...mapGetters({
                'sources': 'getSources',
                'segments': 'getSegments'
            }),
            getFields () {
                let fields = ''

                const indexEmail = indexOf(this.item.content.to, 'email')
                const indexFirstName = indexOf(this.item.content.to, 'first_name')

                if (indexEmail >= 0)
                    fields += this.item.content.from[indexEmail] + ' '

                if (indexFirstName >= 0)
                    fields += this.item.content.from[indexFirstName] + ' '

                return fields.trim()
            },
            source () {
                return findSource(this.item.content.source_id) || {}
            },
            segment () {
                return findSegment(this.item.content.segment_id) || {}
            },
            code () {
                return `(function(w, d, s, f) {
            w['PmlTrackerFields'] = '${this.getFields}'; w['PmlTrackerToken'] = '${this.item.key}'
            var p = d.createElement(s); p.type = 'text/javascript'; p.async = true; p.src = f;
            var c = d.getElementsByTagName('script')[0]; c.parentNode.insertBefore(p, c);
        })(window, document, 'script', 'https://cdn.pumpmylead.com/form-tracker/v1/tracker.js?v=1.0')`
            },
            scriptCode () {
                return `&lt;script type="text/javascript"&gt;
        ${this.code}
    &lt;/script&gt;`
            }
        },
        methods: {
            handleSuccess () {
                Notify.info(trans('info_added_to_your_clipboard'))
            },
            askToDelete () {
                askToDelete()
                    .then((response) => (response.value) ? this.destroy() : null)
            },
            destroy () {
                this.isDeleting = true

                destroyInForms(this.item.id)
                    .then(() => {
                        this.$emit('deleted', this.item.id)
                        Notify.success(trans('_notifications.success'))
                    })
                    .catch(error => Notify.error(trans(error.response.data.slug)))
                    .then(() => { this.isDeleting = false })
            },
            toggleActive () {
                updateInForms(this.item.id, 'active')
                    .then(response => Notify.success(trans('_notifications.success')))
                    .catch((error) => {
                        Notify.error(error.response.data)
                        this.item.active = !this.item.active
                    })
            },
            getSegmentColor (segment) {
                return segment ? segment.color : ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/in_forms/Item.vue